import { combineReducers } from 'redux';

import cards from '@/store/ducks/cards';
import divergences from '@/store/ducks/divergences';
import filter from '@/store/ducks/filter';
import inspectionsReducer from '@/store/ducks/inspections/reducer';
import inspectors from '@/store/ducks/inspectors';
import ordersReducer from '@/store/ducks/orders/reducer';
import schedule from '@/store/ducks/schedule';
import tags from '@/store/ducks/tags';
import toasts from '@/store/ducks/toasts';

const rootReducer = combineReducers({
  cards,
  filter,
  tags,
  inspectors,
  schedule,
  toasts,
  orders: ordersReducer,
  inspections: inspectionsReducer,
  divergences,
});


export default rootReducer;
